import React from 'react';
import { Button, Icon } from 'semantic-ui-react';
import RequestEditModalBody from './components/RequestEditModalBody';
import Modal from '../../../../modules/foundation/components/Modal';
import { BusinessPropType } from '../../../../services/proptypes';
import FishermanLogo from '../FishermanLogo';
var defaultProps = {
  open: false,
  onOpen: function onOpen() {
    return null;
  },
  onClose: function onClose() {
    return null;
  },
  showRequesterInformation: false
};
export default function RequestEditModal(_ref) {
  var business = _ref.business,
    open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    handlePublishOpen = _ref.handlePublishOpen,
    showRequesterInformation = _ref.showRequesterInformation;
  return /*#__PURE__*/React.createElement(Modal, {
    id: "request-edit-modal",
    trigger: /*#__PURE__*/React.createElement(Button, {
      id: "request-edit-button",
      className: "payment-request-button",
      onClick: onOpen
    }, "Request an edit"),
    className: "modal-container request-edit-modal",
    dimmer: "inverted",
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    closeIcon: /*#__PURE__*/React.createElement(Button, {
      id: "inside-close-icon",
      className: "inside-close-icon",
      icon: true
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "close"
    }))
  }, /*#__PURE__*/React.createElement(FishermanLogo, null), /*#__PURE__*/React.createElement(RequestEditModalBody, {
    business: business,
    onClose: onClose,
    handlePublishOpen: handlePublishOpen,
    showRequesterInformation: showRequesterInformation
  }));
}
RequestEditModal.defaultProps = defaultProps;